// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"251f43bd","124":"37d3572a","449":"fb5e0759","651":"b84016c6"}[chunkId] + ".chunk.js";
};